module.exports = __webpack_public_path__ + "static/media/thee.601b8af9.png";